import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import axios from "axios";
import '../../App.css';

export default function OviewReports() {
    useEffect(() => {
        document.title = "Reports"; // Set the tab name
    }, []);

    const [example_data, setExample] = useState([
    {
        id: 1,
        reportedBy: {
        name: "Jane Doe",
        role: "01-0002-00000",
        avatar: "https://via.placeholder.com/40"
        },
        title: "Factors Affecting Enrollment",
        category: "Budget Report",
        dateDue: "23/08/2024",
        status: "In Progress"
    },
    {
        id: 2,
        reportedBy: {
        name: "John Doe",
        role: "01-0001-00000",
        avatar: "https://via.placeholder.com/40"
        },
        title: "Graduations VS Internships",
        category: "White Paper Report",
        dateDue: "23/08/2024",
        status: "Done"
    }
    ]);

      // for testing, set reports_data initial state to example_data
    const [reports_data, setReports] = useState(example_data);

    useEffect(() => {
        axios.get('https://docuquest-swu.swucite.tech/api_drts/reports.php')
        .then((response)=> {            
            const reports = response.data.map(report => ({
                // TODO

            }));
            
            setReports(reports);
        }).catch((err)=> {
            //console.error("ERROR: ",err)
        });        
        
    }, [reports_data]); 

    const [searchValue, setSearchValue] = useState("");

    const [dataCounts, setDataCounts] = useState({
        reportsCompleted: 0,
        reportsInProgress: 0
    });

    const [updateTrigger, setUpdateTrigger] = useState(false);
    
    const abbreviateNumber = (number) => {
        if (number >= 1_000_000) {
            return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M'; // Abbreviate to 'M' for millions
        } else if (number >= 1_000) {
            return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K'; // Abbreviate to 'K' for thousands
        }
        return number.toString(); // Return the number as a string if under 1,000
    };

    useEffect(() => {
        const fetchDataCounts = async () => {
          try {
            const response = await axios.get('https://docuquest-swu.swucite.tech/api_drts/your-endpoint.php'); // TODO refer to api folder in htdocs
            setDataCounts({
              reportsCompleted: abbreviateNumber(response.data.reportsCompleted),
              reportsInProgress: abbreviateNumber(response.data.reportsInProgress),
            });
          } catch (error) {
            //console.error("Error fetching data counts:", error);
          }
        };
    
        fetchDataCounts();
    }, [updateTrigger]); // Only calls when updateTrigger changes

    useEffect(()=>{
        // TODO axios get from reports in db

    }, []);

    const handleSearchChange = (e) => {
        const searchQuery = e.target.value.toLowerCase();
        setSearchValue(searchQuery);

        // for testing, filter from example_data
        const filteredBySearch = example_data.filter((report) =>
            Object.values(report).some((val) =>
              // if attribute is string, check if search query matches with it
              typeof val === "string"
                ? val.toLowerCase().includes(searchQuery)
              // if attribute is object, check if search query matches with its inner attributes
                : typeof val === "object"
                ? Object.values(val)
                    .some((nestedVal) =>
                      String(nestedVal).toLowerCase().includes(searchQuery)
                    )
                : false
            )
          );

        setReports(filteredBySearch);
        setPageNow(1);
    }

    const [pageNow, setPageNow] = useState(1);
    const rowsNow = 15;
    const indxLast = pageNow * rowsNow;
    const indxFirst = indxLast - rowsNow;
  
    const paginatedReports = reports_data.slice(indxFirst, indxLast);
    const pageTotal = Math.ceil(reports_data.length / rowsNow);
    const pageNumbers = [...Array(pageTotal + 1).keys()].slice(1);
  
    const pagePrev = () => {
      if (pageNow > 1) setPageNow(pageNow - 1);
    };
  
    const pageNext = () => {
      if (pageNow < pageTotal) setPageNow(pageNow + 1);
    };
  
    const changePage = (id) => {
      setPageNow(id);
    };

    const refreshTopData = () => {
        setUpdateTrigger(!updateTrigger);
    };    

    const navigate = useNavigate();

    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <div>
            <header className="header">
                {/* TODO dropdown filter by */}
                <input 
                   type="text"
                   placeholder="Search"
                   value={searchValue}
                   onChange={handleSearchChange}
                   className="search-input right"   
                />
            </header>
            {/* TODO class for section where the 2 stat_box will fill the width */}
            <section className='dash_overview'>
                <article className='stat_box standalone'>
                    <h6 className='title'>Completed</h6>
                    <p className='title body'>{dataCounts.reportsCompleted}</p>
                </article>
                <article className='stat_box standalone'>
                    <h6 className='title'>In&nbsp;Progress</h6>
                    <p className='title body'>{dataCounts.reportsInProgress}</p>
                </article>
            </section>
            
            <table className="documents-table">
                <thead>
                {reports_data.length > 0 && (
                    <tr>
                        <th>Reported by</th>
                        <th>Title</th>
                        <th>Category</th>
                        <th>Date&nbsp;Due</th>
                        <th>Status</th>
                    </tr>   
                )}    
                </thead>
                <tbody>
                {/* TODO clicking on name leads to profile, just ike user mgmt */}
                {paginatedReports.map((report) => (
                    <tr key={report.id}>
                    <td>
                        <div className="requester-info">
                        <img src={report.reportedBy.avatar} alt="Avatar" className="avatar" />
                        <div>
                            <div>{report.reportedBy.name}</div>
                            <div className="role">{report.reportedBy.role}</div>
                        </div>
                        </div>
                    </td>
                    <td>{report.title}</td>
                    <td>{report.category}</td>
                    <td>{report.dateDue}</td>
                    <td className={`status ${report.status.toLowerCase().replace(' ', '-')}`}>
                        {report.status}
                    </td>
                    </tr>
                ))}                
                </tbody>
            </table>
            {
            paginatedReports.length > 0 && (
                <div className="pagination">
                    <button onClick={() => changePage(1)} disabled={pageNow === 1}>
                        &lt;&lt;
                    </button>
                    <button onClick={pagePrev} disabled={pageNow === 1}>
                        &lt; Previous
                    </button>
                    {pageNumbers.map((number) => (
                        <button
                        key={number}
                        onClick={() => changePage(number)}
                        className={pageNow === number ? "active" : ""}
                        >
                        {number}
                        </button>
                    ))}
                    <button onClick={pageNext} disabled={pageNow === pageTotal}>
                        Next &gt;
                    </button>
                    <button onClick={() => changePage(pageTotal)} disabled={pageNow === pageTotal}>
                        &gt;&gt;
                    </button>
                </div> 
            )}
        </div>
    )
}